import { render, staticRenderFns } from "./ClientCasesMultiSelect.vue?vue&type=template&id=bb908aa8"
import script from "./ClientCasesMultiSelect.vue?vue&type=script&lang=js"
export * from "./ClientCasesMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports